const UrlEncodeInput = () => null;

export default UrlEncodeInput;
